module.exports = __webpack_public_path__ + "9c12749bbe329aaf4506d82eafd63e0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-31.png
// module id = 2473
// module chunks = 0